import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, QueryParamsHandling, Router } from '@angular/router';
import { SidenavOption } from '@ml/core/types/interfaces/sidenav-option.interface';
import { User } from '@ml/core/types/classes/user.class';

@Component({
  selector: 'ml-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  collapsed: boolean;
  hidden: boolean;

  @Input() user: User;
  @Input() sidenavOptions: SidenavOption[];
  @Input() active: string;

  constructor(private router: Router) {}

  ngOnInit() {
    this.collapsed = false;
  }

  isOptionVisible(option: SidenavOption) {
    return option.role.indexOf(this.user.role) >= 0;
  }

  get collapsedIcon() {
    return this.collapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left';
  }

  onClickOption(link: string) {
    // let queryParamsHandling: QueryParamsHandling = '';
    // const url = this.router.url;
    // if (url.split('/')[1].startsWith(link)) {
    //   queryParamsHandling = 'preserve';
    // }
    this.router.navigate([link]);
  }
}
